// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orders-wrapper {
  margin: 20px;
}

.order-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.order-item {
  display: flex;
  align-items: center;  
  border-bottom: 1px solid #EAEAEA;
  margin-bottom: 27px;
}

.order-item .left {
  display: flex;
  flex-direction: column;
}

.order-item .left .subtitle {
  color: #9C9C9C;
  font-size: 12px;
  margin-bottom: 4px;
}

.order-item .left .title {
  color: #236ABC;
  font-family: 20px;
  margin-bottom: 10px;
}

.order-item .left .caption {
  color: #000000;
  font-family: 12px;
  margin-bottom: 10px;
}

.btn-view {
  text-decoration: none;
  border: 1px solid #005c0f;
  color: #005c0f;
  padding: 11px 24px;
  border-radius: 5px;
}

.btn-edit {
  border: 1px solid #005c0f;
  color: #005c0f;
  padding: 10px 24px;
  border-radius: 5px;
  background-color: #fff;
  margin-right: 10px;
  cursor: pointer;
}

.order-details-wrapper {
  margin: 20px;
}

.btn-back {
  color: #000;
  font-family: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.btn-back img {
  width: 8px;
  margin-right: 10px;
}

.details-section-container {
  background-color: #E9E9E9;
  padding: 12px 7px;
}

.details-section-container .row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
  font-size: 16px;
}
.details-section-container .row:last-child {
  margin-bottom: 0px;
}

.details-section-container .row .column:last-child {
  font-weight: bold;
}

.order-summary-title {
  margin: 15px 0 20px;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: bold;
  line-height: 14px;
  letter-spacing: 1px;
}

.order-products-list {
  width: 100%;
}

.order-products-list .row {
  display: flex;
  align-items: center;
  justify-content: space-between; 
}

.order-products-list .row .column {
  width: 100%;
}

.order-products-list .row .column:last-child {
  width: 50%;
}

.order-products-list .row.row-title {
  font-size: 12px;
  font-weight: 500;
  color: #4A4A4A;
  letter-spacing: .5px;
  border-bottom: 1px solid #EAEAEA;
  padding-bottom: 7px;
}

.order-products-list .row-item {
  padding: 14px 0px;
  border-bottom: 1px solid #EAEAEA;
}

.order-products-list .row-item .column:first-child {
  font-size: 16px;
} 

.order-products-list .row-item .unit-details {
  display: block;
  float: left;
  background-color: #F6F6F6;
  border-radius: 5px;
  padding: 10px 20px;
}


.order-products-list .row-item .label-column .label-value {
  font-size: 16px;
  color: #000;
  margin-right: 20px;
  font-weight: bold;
} 

.order-products-list .row-item .label-column .label-unit{
  font-size: 14px;
} 


.input-unit-details {
  visibility: hidden;
}

`, "",{"version":3,"sources":["webpack://./src/components/PreviousOrders/previousOrders.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,kBAAkB;AACpB","sourcesContent":[".orders-wrapper {\n  margin: 20px;\n}\n\n.order-menu {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.order-item {\n  display: flex;\n  align-items: center;  \n  border-bottom: 1px solid #EAEAEA;\n  margin-bottom: 27px;\n}\n\n.order-item .left {\n  display: flex;\n  flex-direction: column;\n}\n\n.order-item .left .subtitle {\n  color: #9C9C9C;\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n.order-item .left .title {\n  color: #236ABC;\n  font-family: 20px;\n  margin-bottom: 10px;\n}\n\n.order-item .left .caption {\n  color: #000000;\n  font-family: 12px;\n  margin-bottom: 10px;\n}\n\n.btn-view {\n  text-decoration: none;\n  border: 1px solid #005c0f;\n  color: #005c0f;\n  padding: 11px 24px;\n  border-radius: 5px;\n}\n\n.btn-edit {\n  border: 1px solid #005c0f;\n  color: #005c0f;\n  padding: 10px 24px;\n  border-radius: 5px;\n  background-color: #fff;\n  margin-right: 10px;\n  cursor: pointer;\n}\n\n.order-details-wrapper {\n  margin: 20px;\n}\n\n.btn-back {\n  color: #000;\n  font-family: 16px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.btn-back img {\n  width: 8px;\n  margin-right: 10px;\n}\n\n.details-section-container {\n  background-color: #E9E9E9;\n  padding: 12px 7px;\n}\n\n.details-section-container .row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 7px;\n  font-size: 16px;\n}\n.details-section-container .row:last-child {\n  margin-bottom: 0px;\n}\n\n.details-section-container .row .column:last-child {\n  font-weight: bold;\n}\n\n.order-summary-title {\n  margin: 15px 0 20px;\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: bold;\n  line-height: 14px;\n  letter-spacing: 1px;\n}\n\n.order-products-list {\n  width: 100%;\n}\n\n.order-products-list .row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between; \n}\n\n.order-products-list .row .column {\n  width: 100%;\n}\n\n.order-products-list .row .column:last-child {\n  width: 50%;\n}\n\n.order-products-list .row.row-title {\n  font-size: 12px;\n  font-weight: 500;\n  color: #4A4A4A;\n  letter-spacing: .5px;\n  border-bottom: 1px solid #EAEAEA;\n  padding-bottom: 7px;\n}\n\n.order-products-list .row-item {\n  padding: 14px 0px;\n  border-bottom: 1px solid #EAEAEA;\n}\n\n.order-products-list .row-item .column:first-child {\n  font-size: 16px;\n} \n\n.order-products-list .row-item .unit-details {\n  display: block;\n  float: left;\n  background-color: #F6F6F6;\n  border-radius: 5px;\n  padding: 10px 20px;\n}\n\n\n.order-products-list .row-item .label-column .label-value {\n  font-size: 16px;\n  color: #000;\n  margin-right: 20px;\n  font-weight: bold;\n} \n\n.order-products-list .row-item .label-column .label-unit{\n  font-size: 14px;\n} \n\n\n.input-unit-details {\n  visibility: hidden;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
